<template>
  <div class="metadata-input-field-container">
    <template v-if="inputWindowKey == INPUT_TYPES.text">
      <v-text-field v-bind="inputAttrs" v-model="fieldValue" @input="emitChange"></v-text-field>
    </template>
    <template v-else-if="inputWindowKey == INPUT_TYPES.dateTime">
      <DateTimeMetadataInput v-bind="inputAttrs" v-model="fieldValue" @input="emitChange" />
    </template>
    <template v-else-if="inputWindowKey == INPUT_TYPES.monitoringLocation">
      <ComboboxMetadataInput v-model="fieldValue" v-bind="inputAttrs" label="Monitoring Location" :items="discreteStationNames" @input="emitChange" />
    </template>
    <template v-else-if="inputWindowKey == INPUT_TYPES.monitoringComponent">
      <ComboboxMetadataInput v-model="fieldValue" v-bind="inputAttrs" label="Monitoring Component" :items="stationCategoriesNameList" @input="emitChange" />
    </template>
  </div>
</template>

<script>
  import MetadataUtil from '@/components/mixins/MetadataUtil'
  import MomentUtil from '@/components/mixins/MomentUtil'
  import ComboboxMetadataInput from './Inputs/ComboboxMetadataInput'
  import DateTimeMetadataInput from './Inputs/DateTimeMetadataInput'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const stations = createNamespacedHelpers('stations')
  const dataSources = createNamespacedHelpers('datasource')

  const INPUT_TYPES = {
    text: 'Text',
    dateTime: 'DateTime',
    monitoringLocation: 'MonitoringLocation',
    monitoringComponent: 'MonitoringComponent',
  }

  export default {
    components: {
      ComboboxMetadataInput,
      DateTimeMetadataInput,
    },
    mixins: [MetadataUtil, MomentUtil],
    props: {
      inputType: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Array],
        required: true,
      },
      ignoreValidate: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        INPUT_TYPES,
        menu: false,
        fieldValue: '',
        selectedLocations: null,
      }
    },
    computed: {
      ...stations.mapGetters(['stationCategories']),
      ...dataSources.mapGetters(['dataSources']),
      discreteStations() {
        return this.dataSources[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStationNames() {
        return this.discreteStations && this.discreteStations.map(ds => ds.LocationIdentifier)
      },
      inputWindowKey() {
        if (['String', 'Number'].includes(this.metadataType)) {
          return INPUT_TYPES.text
        } else if (
          [
            INPUT_TYPES.dateTime,
            INPUT_TYPES.monitoringLocation,
            INPUT_TYPES.monitoringComponent,
          ].includes(this.metadataType)
        ) {
          return this.metadataType
        } else {
          return INPUT_TYPES.text
        }
      },
      inputAttrs() {
        let defaultAttrs = {
          label: `${this.inputType} Field Value`,
          rules: this.ignoreValidate ? [] : this.inputRules(this.metadataType),
        }
        if (this.type === INPUT_TYPES.dateTime) {
          defaultAttrs['label'] = 'Date (YYYY-mm-dd)'
        }
        let val = Object.assign(defaultAttrs, this.$attrs)
        return val
      },
      metadataType() {
        if (
          this.fieldTypeNames
          .map(x => x.toLowerCase())
          .includes(this.inputType.toLowerCase())
        ) {
          return this.inputType
        }
        return 'String'
      },
      stationCategoriesNameList() {
        let stationCats = JSON.parse(
          JSON.stringify(this.stationCategories)
        )
        return stationCats
          .sort((a, b) => (a.Name > b.Name ? 1 : -1))
          .map(e => e.Name)
      },
    },
    watch: {
      value() {
        this.setFormValue()
      },
      inputType() {
        this.setFormValue()
      },
      selectedLocations(value) {
        let names = []
        value.forEach(location => {
          let discreteStation = location.dataTypesIndex[SOURCE_TYPES.discreteEnvirodata]
          names.push(discreteStation.LocationIdentifier)
        })
      },
    },
    methods: {
      setFormValue() {
        this.fieldValue = this.parseTypeFromString(
          this.inputType,
          this.value
        )
      },
      emitChange() {
        let value = this.isGroupedFieldType(this.inputType) ?
          this.fieldValue :
          this.encodeTypeToString(this.inputType, this.fieldValue)
        this.$emit('input', value)
      },
    },
    mounted() {
      this.setFormValue()
    },
  }
</script>

<style lang="stylus" scoped>
  div.metadata-input-field-container {
    width: 100%;
    height: 100%;
  }
</style>